import { BOOKKEEPER_ACCOUNT_TYPES } from '../constants';
import _ from 'lodash';

/**
 * Gets whether the current user is a tax expert.
 * Tax experts can be either tax pros or paid preparers.
 */
export const isTaxExpertSelector = (state) =>
  _.get(state, ['auth', 'user', 'accountType']) === BOOKKEEPER_ACCOUNT_TYPES.TAX_EXPERT;

/**
 * Gets whether the current user is a tax pro.
 * Tax pros are a subset of tax experts.
 */
export const isTaxProSelector = (state) => _.get(state, ['auth', 'user', 'isTaxPro']);

/**
 * Gets whether the current user has admin-level access.
 * Internal accounts inherit all admin permissions.
 */
export const isAdminSelector = (state) => {
  const accountType = _.get(state, ['auth', 'user', 'accountType']);
  return accountType === BOOKKEEPER_ACCOUNT_TYPES.ADMIN || accountType === BOOKKEEPER_ACCOUNT_TYPES.INTERNAL;
};

/**
 * Gets whether the current user is an internal account.
 * Internal accounts have all admin permissions plus internal-only access (e.g. user data export/import).
 */
export const isInternalSelector = (state) =>
  _.get(state, ['auth', 'user', 'accountType']) === BOOKKEEPER_ACCOUNT_TYPES.INTERNAL;
